import Icon from './Icon';
import styles from './LinkCard.module.css';

export default function LinkCard({ link }) {
  return (
    <a
      href={link.url}
      target="_blank"
      rel="noopener noreferrer"
      className={`${styles.card} ${link.featured ? styles.featured : ''}`}
      style={
        link.featured
          ? { background: 'rgba(216,90,48,0.11)', borderColor: 'rgba(216,90,48,0.32)' }
          : {}
      }
    >
      {/* Ícono */}
      <div
        className={styles.iconWrap}
        style={{ background: link.iconBg }}
      >
        <Icon name={link.id} size={22} color={link.iconColor} />
      </div>

      {/* Texto */}
      <div className={styles.text}>
        <span className={styles.label}>
          {link.label}
          {link.featured && <span className={styles.badge}>✦</span>}
        </span>
        <span className={styles.desc}>{link.desc}</span>
      </div>

      {/* Flecha */}
      <Icon
        name="arrowRight"
        size={16}
        color={link.featured ? link.iconColor : 'rgba(255,255,255,0.28)'}
      />
    </a>
  );
}
